//projet PAPAR
import paparImage13 from '../images/realisation/Projet PAPAR/image 13.png';
import paparImage15 from '../images/realisation/Projet PAPAR/image 15.png';
import paparImage16 from '../images/realisation/Projet PAPAR/image 16.png';
import paparImage17 from '../images/realisation/Projet PAPAR/image 17.png';

//manawan
import manawanImage1 from '../images/realisation/Auberge Manawan/image.png';
import manawanImage2 from '../images/realisation/Auberge Manawan/image2.png';
import manawanImage3 from '../images/realisation/Auberge Manawan/image3.png';

//agrandissement poste de police
import postePoliceImage1 from '../images/realisation/Agrandissement Poste de police opiticiwan/image.png';
import postePoliceImage2 from '../images/realisation/Agrandissement Poste de police opiticiwan/image2.png';
import postePoliceImage3 from '../images/realisation/Agrandissement Poste de police opiticiwan/image3.png';
import postePoliceImage4 from '../images/realisation/Agrandissement Poste de police opiticiwan/image4.png';
import postePoliceImage5 from '../images/realisation/Agrandissement Poste de police opiticiwan/image5.png';

//caisse desjardins
import caisseDesjardinsImage1 from '../images/realisation/Caisse Les boulevard de TR/image.png';
import caisseDesjardinsImage2 from '../images/realisation/Caisse Les boulevard de TR/image2.png';
import caisseDesjardinsImage3 from '../images/realisation/Caisse Les boulevard de TR/image3.png';

//colisée
import coliseeImage1 from '../images/realisation/Colisés Denis-morel/image.png';
import coliseeImage2 from '../images/realisation/Colisés Denis-morel/image2.png';
import coliseeImage3 from '../images/realisation/Colisés Denis-morel/image3.png';
import coliseeImage4 from '../images/realisation/Colisés Denis-morel/image4.png';

//CSSSM
import csmImage1 from '../images/realisation/CSSSSM/image.png';

//garage hyundai
import garageHyundaiImage1 from '../images/realisation/Garage Hyaundai/image.png';
import garageHyundaiImage2 from '../images/realisation/Garage Hyaundai/image2.png';
import garageHyundaiImage3 from '../images/realisation/Garage Hyaundai/image3.png';

//garage hydro quebec
import garageHydroQuebecImage1 from '../images/realisation/Garage Hydro Québec - Centrale Rapide-Blanc/image.png';
import garageHydroQuebecImage2 from '../images/realisation/Garage Hydro Québec - Centrale Rapide-Blanc/image2.png';

//lac bouchette
import lacBouchetteImage1 from '../images/realisation/Garage municipal lac bouchette/image.jpg';
import lacBouchetteImage2 from '../images/realisation/Garage municipal lac bouchette/image2.png';
import lacBouchetteImage3 from '../images/realisation/Garage municipal lac bouchette/image3.png';

//huit logements
import huitLogementsImage1 from '../images/realisation/Huit logement - Chisasibi/image.png';
import huitLogementsImage2 from '../images/realisation/Huit logement - Chisasibi/image2.png';
import huitLogementsImage3 from '../images/realisation/Huit logement - Chisasibi/image3.png';

//westrock
import westrockImage1 from '../images/realisation/Westrock/image.png';
import westrockImage2 from '../images/realisation/Westrock/image2.png';

//logement supervisé
import logementSuperviseImage1 from '../images/realisation/Logement supervisés/image.png';
import logementSuperviseImage2 from '../images/realisation/Logement supervisés/image2.png';
import logementSuperviseImage3 from '../images/realisation/Logement supervisés/image3.png';
import logementSuperviseImage4 from '../images/realisation/Logement supervisés/image4.png';

//marché d'alimentation
import marcheAlimentationImage1 from '../images/realisation/Marché d\'alimentation Manawan/image.png';
import marcheAlimentationImage2 from '../images/realisation/Marché d\'alimentation Manawan/image2.png';
import marcheAlimentationImage3 from '../images/realisation/Marché d\'alimentation Manawan/image3.png';

//palais de justice
import palaisJusticeImage1 from '../images/realisation/Palais de justice/image.png';
import palaisJusticeImage2 from '../images/realisation/Palais de justice/image2.png';
import palaisJusticeImage3 from '../images/realisation/Palais de justice/image3.png';
import palaisJusticeImage4 from '../images/realisation/Palais de justice/image4.png';

//poste de police
import postePolice2Image1 from '../images/realisation/poste de police/image.png';
import postePolice2Image2 from '../images/realisation/poste de police/image2.png';
import postePolice2Image3 from '../images/realisation/poste de police/image3.png';

//restaurant A&W
import restaurantAWImage1 from '../images/realisation/Restaurant A&W/image.png';

//centre mamonikotiwam
import centreMamonikotiwamImage1 from '../images/realisation/Centre Manonikotiwam/image1.png';
import centreMamonikotiwamImage2 from '../images/realisation/Centre Manonikotiwam/image2.png';
import centreMamonikotiwamImage3 from '../images/realisation/Centre Manonikotiwam/image3.png';
import centreMamonikotiwamImage4 from '../images/realisation/Centre Manonikotiwam/image4.png';
import centreMamonikotiwamImage5 from '../images/realisation/Centre Manonikotiwam/image5.png';
import centreMamonikotiwamImage6 from '../images/realisation/Centre Manonikotiwam/image6.png';
import centreMamonikotiwamImage7 from '../images/realisation/Centre Manonikotiwam/image7.png';
import centreMamonikotiwamImage8 from '../images/realisation/Centre Manonikotiwam/image8.png';

//hydro-québec
import hydroQuebecImage1 from '../images/realisation/barrage/image.png';
import hydroQuebecImage2 from '../images/realisation/barrage/image2.png';

//la tuque
import laTuqueImage1 from '../images/realisation/latuque/image.png';
import laTuqueImage2 from '../images/realisation/latuque/image2.png';


const realisations = [
    {
        id: 1,
        title: "Nouveau bâtiment Projet PAPAR",
        client: "Conseil des Atikamekw d'Opitciwan",
        miniatures: [paparImage13],
        images: [paparImage13, paparImage15, paparImage16, paparImage17],
        description: "Le projet consiste en un nouveau bâtiment annexé au Centre de pédiatrie sociale à Opitciwan. S'apparentant à un centre de la petite enfance, son objectif est de répondre au Programme d'aide préscolaire aux Autochtones dans les réserves de Services aux autochtones Canada. La firme a réalisé l'ingénierie complète en civil/structure, mécanique et électricité du bâtiment et a été mandatée pour la surveillance de chantier. L'emplacement du bâtiment a apporté quelques enjeux au niveau de l'aménagement civil et de la structure. Aussi, la communauté n'étant pas raccordée au réseau d'Hydro-Québec, les projets à Opitciwan comportent toujours une complexité supplémentaire pour le chauffage des bâtiments.",
        prix: "11 millions $",
        categorie: "building",
    },
    {
        id: 2,
        title: "Nouveau poste de police - Wemotaci",
        client: "Conseil des Atikamekw de Wemotaci",
        miniatures: [postePolice2Image1],
        images: [postePolice2Image1, postePolice2Image2, postePolice2Image3],
        description: "La construction d'un nouveau poste de police pour la communauté de Wemotaci était attendu depuis plusieurs années en raison de la désuétude des installations en place. Cette nouvelle infrastructure permet maintenant au service de police d'effectuer ses interventions dans un environnement sécuritaire. La firme a réalisé l'ingénierie complète en civil/structure, mécanique et électricité du bâtiment. La bâtisse d'une superficie de 500m2, comprend entre autres, le secteur carcéral, des bureaux, une salle de réunion, une aire de repos et un garage. La conception de systèmes spéciaux et de toutes les particularités reliées au milieu carcéral a été réalisée avec rigueur conformément aux exigences de la Société québécoise des infrastructures.",
        prix: "5,4 millions $",
        categorie: "building",
    },
    {
        id: 3,
        title: "Caisse Les Boulevards de Trois-Rivières – Agrandissement et réaménagement",
        client: "Caisse des Trois-Rivières",
        miniatures: [caisseDesjardinsImage1],
        images: [caisseDesjardinsImage1, caisseDesjardinsImage2, caisseDesjardinsImage3],
        description: "Ce projet comprenait un agrandissement du bâtiment en hauteur et le réaménagement complet de la partie conservée. La complexité du projet consistait à le réaliser par phases, afin de conserver les services courants en fonction pendant toute la durée du chantier. Le design particulier du bâtiment, dont une bonne partie est construite en porte-à-faux, nous a permis de réaliser de beaux défis de structure. Comme mesure d'économie d'énergie, les deux centrales d'air ont été sélectionnées afin d'obtenir la meilleure efficacité possible. Des boîtes de fin de course à volume variable optimisent aussi les dépenses énergétiques. Comme mesure particulière, des entraînements à fréquences variables permettent de doser le volume d'air en fonction de la demande et des sondes de CO2 modulent le volet d'entrée d'air frais, ce qui diminue de beaucoup les dépenses énergétiques. Ces deux mesures d'efficacité énergétique sont d'ailleurs reconnues par Hydro-Québec et ont permis d'obtenir un maximum de subventions pour le projet.",
        prix: "5 millions $",
        categorie: "building",
    },
    {
        id: 4,
        title: "Marché d'alimentation Manawan",
        client: "Marché d'alimentation Manawan / Sobey's",
        miniatures: [marcheAlimentationImage1],
        images: [marcheAlimentationImage1, marcheAlimentationImage2, marcheAlimentationImage3],
        description: "L'agrandissement et le réaménagement du marché d'alimentation étaient devenus nécessaires pour répondre aux besoins des familles de la communauté. C'est ainsi qu'un agrandissement de 800 pi2, un réaménagement de l'espace existant et l'acquisition de nouveaux équipements permettront aux clients d'avoir accès à une plus grande variété de denrées et de bénéficier de meilleurs services. Le Groupe DLA S.E.N.C. a réalisé l'ingénierie en civil/structure - Mécanique et électricité du bâtiment et s'est vu confié la gestion de la construction du projet.",
        prix: "850 000 $",
        categorie: "building",
    },
    {
        id: 5,
        title: "Garage Hyundai - Saguenay",
        client: "Gestion Pierre Couture inc.",
        miniatures: [garageHyundaiImage1],
        images: [garageHyundaiImage1, garageHyundaiImage2, garageHyundaiImage3],
        description: "Ce projet consistait en la construction d'une bâtisse pour un concessionnaire automobile Hyundai à Jonquière. Ce bâtiment d'une superficie de 20 000 pi2, comprenait entre autres, un centre de services et une salle de montre. On a confié à Groupe DLA S.E.N.C. la réalisation de l'ingénierie complète en mécanique et électricité du bâtiment. La gestion de la construction compte parmi les services fournis au client.",
        prix: "N/A",
        categorie: "building",
    },
    {
        id: 6,
        title: "Auberge Manawan",
        client: "Conseil des Atikamekw de Manawan",
        miniatures: [manawanImage1],
        images: [manawanImage1, manawanImage2, manawanImage3],
        description: "Groupe DLA S.E.N.C. est fier d'avoir participé à la réalisation du projet de construction de l'Auberge Manawan située sur la réserve autochtone portant le même nom. L'auberge d'une superficie de trois étages de 2 500 pi2 comporte 10 unités de location, et une salle de conférence. Le mandat consistait à réaliser l'ingénierie complète en civil / structure, mécanique et électricité du bâtiment. La gestion de la construction ainsi que l'aménagement du terrain faisaient également partie des services livrés au client. Groupe DLA S.E.N.C. travaille actuellement sur un projet d'agrandissement de l'auberge.",
        prix: "1 300 000 $",
        categorie: "building",
    },
    {
        id: 7,
        title: "Palais de justice de La Tuque",
        client: "Carrefour de La Tuque",
        miniatures: [palaisJusticeImage1],
        images: [palaisJusticeImage1, palaisJusticeImage2, palaisJusticeImage3, palaisJusticeImage4],
        description: "Le client, le carrefour La Tuque, fournit des locaux à la Société québécoise des infrastructures depuis plusieurs années pour y tenir les activités du Palais de justice de La Tuque. Pour assurer la sécurité des utilisateurs, un agrandissement et un réaménagement complet des installations étaient devenus nécessaires. Le Groupe DLA S.E.N.C. est particulièrement fier d'avoir collaboré à la mise en œuvre de ce projet d'envergure depuis le début de sa conception. Toute l'ingénierie civile /structure, en mécanique et électricité du bâtiment a été réalisée par Groupe DLA S.E.N.C.. La gestion de la construction a aussi été assumée par la firme. L'ajout de nouveaux locaux a été nécessaire en 2022. Satisfait de la qualité des services rendus dans le projet initial, le client a engagé le Groupe DLA S.E.N.C. afin de réaliser l'ingénierie en mécanique du bâtiment et électricité.",
        prix: "5 000 000 $",
        categorie: "building",
    },
    {
        id: 8,
        title: "Huit Logements - Chisasibi",
        client: "Commission Scolaire Crie",
        miniatures: [huitLogementsImage1],
        images: [huitLogementsImage1, huitLogementsImage2, huitLogementsImage3],
        description: "Il s'agit d'un projet de construction d'un immeuble à 8 logements sur deux étages de 6500 pi.2 comprenant aussi un sous-sol servant d'entrepôt. Le Groupe DLA S.E.N.C. a participé activement à ce projet en réalisant l'ingénierie civile/structure ainsi qu'en mécanique et électricité du bâtiment. La gestion de la construction leur a aussi été confiée.",
        prix: "3 400 000 $",
        categorie: "building",
    },
    {
        id: 9,
        title: "Colisée Denis-Morel - Rénovation et agrandissement",
        client: "Bilodeau Baril Leeming Architectes.ca",
        miniatures: [coliseeImage1],
        images: [coliseeImage1, coliseeImage2, coliseeImage3, coliseeImage4],
        description: "La Ville de La Tuque voulait rénover et agrandir le colisé municipal afin d'offrir de meilleurs services à la population et de répondre aux normes de construction en vigueur. La réfection s'est faite sur deux étages de 8 000 pi2 pour réaménager entre autres, les vestiaires, salles d'eau et casse-croûte. Le Groupe DLA S.E.N.C. a été impliqué dès l'étude préliminaire du projet. C'est avec grande fierté qu'il a relevé le défi d'en réaliser l'ingénierie civile/structure en mécanique et électricité du bâtiment. On lui a aussi confié le mandat d'assurer la gestion de la construction.",
        prix: "2 500 000 $",
        categorie: "building",
    },
    {
        id: 10,
        title: "Garage Hydro Québec - Centrale Rapide-Blanc",
        client: "Hydro-Québec",
        miniatures: [garageHydroQuebecImage1],
        images: [garageHydroQuebecImage1, garageHydroQuebecImage2],
        description: "Ce projet consistait en la construction d'un entrepôt sur le site de la centrale Rapide-Blanc pour Hydro-Québec. Ce bâtiment d'une superficie de près de 300m² est composé d'une structure autoportante de marque Honco. Ce bâtiment fut conçu selon les exigences élevées de qualité d'Hydro-Québec. On a confié à Groupe DLA S.E.N.C. la réalisation de l'ingénierie complète en mécanique et électricité du bâtiment. La gestion de la construction rigoureuse particulière exigée par Hydro-Québec compte parmi les services fournis au client.",
        prix: "900 000 $",
        categorie: "building",
    },
    {
        id: 11,
        title: "Garage municipal Lac-Bouchette",
        client: "Municipalité de Lac-Bouchette",
        miniatures: [lacBouchetteImage1],
        images: [lacBouchetteImage1, lacBouchetteImage2, lacBouchetteImage3],
        description: "Le projet consistait à la construction d'un nouveau garage municipal pour la Municipalité de Lac-Bouchette au Lac-St-Jean. Groupe DLA a réalisé l'ensemble de l'ingénierie et la surveillance des travaux. Le garage, d'une superficie de 4000 pi2, sert à l'entreposage et l'entretien de la machinerie de la municipalité. Un bureau et une salle de toilette ont été aménagés à l'intérieur du garage.",
        prix: "500 000 $",
        categorie: "building",
    },
    {
        id: 12,
        title: "Restaurant A&W à Shawinigan - Aménagement",
        client: "Gaétan Hamel",
        miniatures: [restaurantAWImage1],
        images: [restaurantAWImage1],
        description: "Le client avait comme projet de réaménager un bâtiment existant en vue d'en changer la vocation pour une franchise de restauration rapide à Shawinigan. Le bâtiment d'une superficie de 2 600 pi2 a été réaménagé de façon optimale afin d'y installer toutes les installations nécessaires à la restauration rapide. Le mandat confié à Groupe DLA S.E.N.C. consistait à réaliser l'ingénierie complète en mécanique du bâtiment, en électricité, en structure et en aménagement extérieur. La gestion de la construction a aussi été assumée par la firme.",
        prix: "600 000 $",
        categorie: "building",
    },
    {
        id: 13,
        title: "Centre pédiatrique Mamonitokiwan",
        client: "Conseil des Atikamekw d'Opitciwan",
        miniatures: [centreMamonikotiwamImage3],
        images: [centreMamonikotiwamImage3, centreMamonikotiwamImage2, centreMamonikotiwamImage1, centreMamonikotiwamImage4, centreMamonikotiwamImage5, centreMamonikotiwamImage6, centreMamonikotiwamImage7, centreMamonikotiwamImage8],
        description: "Le projet consiste en la construction d'un centre de pédiatrie sociale qui sera géré par les services sociaux de la communauté. La superficie totale projetée du bâtiment est de plus de 12 000 pi2. Le Groupe DLA s.e.n.c. a réalisé l'ingénierie en civil/structure, mécanique et électricité du bâtiment et a aussi effectué la gestion de la construction du projet.",
        prix: "14 000 000 $",
        categorie: "building",
    },
    {
        id: 14,
        title: "Agrandissement - Poste de police à Opitciwan",
        client: "Conseil des Atikamekw d'Opitciwan",
        miniatures: [postePoliceImage4],
        images: [postePoliceImage4, postePoliceImage2, postePoliceImage3, postePoliceImage1, postePoliceImage5],
        description: "Il s'agit d'un projet de réaménagement de 60 m2 et d'un agrandissement de 335 m2 au sous-sol et de même superficie au rez-de-chaussée. L'agrandissement comprend entre autres, un bloc carcéral et deux garages. Groupe DLA S.E.N.C. a réalisé l'ingénierie en civil / structure, mécanique et électricité du bâtiment. La gestion de construction est aussi incluse au mandat.",
        prix: "4 000 000 $",
        categorie: "building",
    },
    {
        id: 15,
        title: "32 Logements supervisés – La Tuque",
        client: "Les Appartements Libère-Toit",
        miniatures: [logementSuperviseImage1],
        images: [logementSuperviseImage1, logementSuperviseImage2, logementSuperviseImage3, logementSuperviseImage4],
        description: "Ce projet d'envergure, tout d'abord porté par des organismes communautaires locaux, répond à la nécessité d'offrir des logements supervisés pour des personnes vivant avec des besoins particuliers. Au total, 32 unités de logement, des bureaux, ateliers, salles communautaires, cuisine collective, etc. occupent quatre niveaux sur une superficie totale de 4 000 m2. Le groupe DLA est très fier d'avoir réalisé l'ingénierie civil/structure, mécanique et électricité du bâtiment. De plus, la firme a assumé la gestion de construction. Évidemment, par son ampleur, ce projet comportait son lot de défis dans chacune des disciplines de l'ingénierie. Mentionnons aussi, que la conception devait répondre aux exigences Novoclimat.",
        prix: "14 millions $",
        categorie: "building",
    },
    {
        id: 16,
        title: "Projets divers - Centre de santé et des services sociaux de la Saint-Maurice",
        client: "Centre de santé et des services sociaux de la Saint-Maurice",
        miniatures: [csmImage1],
        images: [csmImage1],
        description: "Plusieurs projets ont été réalisés dont : Réaménagement des bureaux des nutritionnistes, Réfection des chambres froides, Salle de préparation stérile, Centre mère enfant, Mise à niveau gestion stationnement, Salle d'attente de la radiologie, Rénovation Centre-jeunesse, Remplacement tuyauterie buanderie, Réaménagement dispensaire de Parent, et plusieurs autres.",
        prix: "N/A",
        categorie: "building",
    },
    {
        id: 17,
        title: "Projets divers - Smurfit-WestRock La Tuque",
        client: "Usine Smurfit-WestRock La Tuque",
        miniatures: [westrockImage1],
        images: [westrockImage2],
        description: "Plusieurs projets ont été réalisés dont : Réfection systèmes de ventilation département de la vapeur, Sécurisation accès machine à papier #3 et #4, Ajout passerelles cheminées des précipitateurs des fours à chaux, Réfection cuvier d'acidification des boues, Mur brise vent au basculateur #6, Quai de déchargement ferroviaire d'acide sulfurique, Réfection réservoir liqueur noire 13.5% no2, Installation compresseurs traitement effluents, Pompe surpression eau chaude filtré MP4, Douche d'urgence H2SO4, Tuyauterie liqueur noire 75% vers chaudière #4, Réfection égout scellé Pulperie, Nouveau réservoir stabilisateur de liqueur verte, et plusieurs autres.",
        prix: "N/A",
        categorie: "industrial",
    },
    {
        id: 18,
        title: "Projets divers - Hydro-Québec",
        client: "Hydro-Québec",
        miniatures: [hydroQuebecImage2],
        images: [hydroQuebecImage1],
        description: "Plusieurs projets ont été réalisés dont : Passerelle temporaire pour puits de turbine - Centrale Beaumont, Plate-forme d'entreposage - Centrale La Tuque, Système d'eau de refroidissement - Centrale des Rapides-Des-Coeurs et de la Chute-Allard, Plates-formes pour maintenance des refroidisseurs - Centrale Beaumont, Banc de calibration des masselottes du déclencheur de survitesse - Centrale de Rapide-Blanc, Réaménagement de l'escalier d'accès de la galerie pour tuyauterie - Centrale de Rapide-Blanc, Rampe de mise à l'eau - Centrale des Rapide-Des-Coeurs, Garage - Centrale de Rapide-Blanc, Chariots d'entreposage des poutrelles de maintenance - Barrage et réservoir Gouin, et plusieurs autres.",
        prix: "N/A",
        categorie: "industrial",
    },
    {
        id: 19,
        title: "Projets divers - Ville de La Tuque",
        client: "Ville de La Tuque",
        miniatures: [laTuqueImage2],
        images: [laTuqueImage1],
        description: "Plusieurs projets ont été réalisés dont : Réaménagement du parc St-Eugène, Réaménagement du parc des Érables, Pavage rue des Tilleuls, Prolongement de la rue Montcalm, Réfection du réseau sanitaire de la rue Tessier, Réfection de la rue Kitchener, Aménagement de l'intersection Tessier-Commerciale, Étude transbordement CRD-Écocentre, Réfection de l'intersection des rues Léon-Gervais et de la Rivière, et plusieurs autres.",
        prix: "N/A",
        categorie: "municipal",
    },
];

export default realisations;
